<template>
  <div class="w-28 flex-shrink-0 flex flex-col justify-center capitalize">
    <span class="text-gray-700">{{ userRole }}</span>
    <div v-if="managerScope" class="flex items-center">
      <span class="mt-1 mr-1 text-s text-gray-500">{{ managerScope }}</span>
      <lm-manager-scope-helper
        v-if="managerScope === 'Scoped'"
        :actors="actors"
        class="leading-zero"
      />
    </div>
  </div>
</template>

<script>
import LmManagerScopeHelper from '@/components/ui/LmManagerScopeHelper'
export default {
  name: 'UserRole',
  components: {LmManagerScopeHelper},
  props: {
    userRole: {
      type: String,
      required: true
    },
    managerScope: {
      type: [String, Boolean],
      required: true
    },
    actors: {
      type: Array,
      required: true
    }
  }
}
</script>
